import { GameMode, Stake } from '@/feature/lobby-arcade/hooks/use-arcade-games';
import { create } from 'zustand';

type GameSettings = {
    gameId: string;
    gameMode: GameMode | undefined;
    selectedStake: Stake | null;
    useBetrBucks: boolean;
};

interface GameSettingsStore {
    gameId: GameSettings['gameId'];
    gameMode: GameSettings['gameMode'];
    selectedStake: GameSettings['selectedStake'];
    useBetrBucks: GameSettings['useBetrBucks'];
    actions: {
        setGameSettings: (gameSettings: Partial<GameSettings>) => void;
        toggleBetrBucks: () => void;
    };
}

const defaultGameSettings: GameSettings = {
    gameId: '',
    gameMode: undefined,
    selectedStake: null,
    useBetrBucks: false,
};

// Stores the selected arcade game settings
export const useGameSettingsStore = create<GameSettingsStore>((set, get) => ({
    ...defaultGameSettings,
    actions: {
        setGameSettings: (gameSettings: Partial<GameSettings>) => {
            const currentGameId = get().gameId;
            const newGameId = gameSettings.gameId;

            // If gameId is changing, reset Betr Bucks state to default
            if (newGameId && newGameId !== currentGameId) {
                set({
                    ...gameSettings,
                    useBetrBucks: false,
                });
            } else {
                set(gameSettings);
            }
        },
        toggleBetrBucks: () => {
            const currentUseBetrBucks = get().useBetrBucks;
            set({
                useBetrBucks: !currentUseBetrBucks,
            });
        },
    },
}));
